import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { organization, branding } from "../../config";

export default function FeaturedButtonsPublic() {
  const [buttons, setButtons] = useState([]);
  const [logo, setLogo] = useState({ image: "", text: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [buttonsRes, logoRes] = await Promise.all([
          axios.get("/api/public/buttons"),
          axios.get("/api/public/logo")
        ]);
        setButtons(buttonsRes.data.content || []);
        setLogo(logoRes.data.content || { image: "", text: "" });
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return null;
  }

  if (buttons.length === 0) {
    return null;
  }

  return (
    <section
      style={{
        fontFamily: "'Montserrat', sans-serif",
        padding: "30px 40px 50px 40px",
        backgroundColor: "#025387",
        position: "relative",
        marginBottom: "40px",
      }}
    >
      <div
        className="container"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px",
          flexWrap: "wrap",
        }}
      >
        {buttons.map((button, index) => (
          <Link
            key={index}
            to={`/${button.link}`}
            className="btn px-4 py-2 fw-bold text-white"
            style={{
              backgroundColor: button.color || branding.primaryColor,
              border: "none",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              transition: "transform 0.2s, opacity 0.2s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
              e.currentTarget.style.opacity = "0.9";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.opacity = "1";
            }}
          >
            {button.label}
          </Link>
        ))}
      </div>
      
      {/* Logo centered at bottom, overlapping the section edge */}
      {logo.image && (
        <img
          src={logo.image}
          alt={logo.text || organization.name}
          style={{
            position: "absolute",
            bottom: "-40px",
            left: "50%",
            transform: "translateX(-50%)",
            height: "80px",
            width: "auto",
            zIndex: 10,
          }}
        />
      )}
    </section>
  );
}
